module.exports = __webpack_public_path__ + "img/u.1b0c9679.jpg";